module.exports = __webpack_public_path__ + "img/debit-card.d262c967.png";